import React, { useState, useEffect } from "react";
import Select from "react-select";
import "../../assets/css/inventorymanagement.css"
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL"

const InventoryPolicies = () => {
  const [ropMethod, setRopMethod] = useState(null);
  const [orderFrequency, setOrderFrequency] = useState(null);
  const [backorderPolicy, setBackorderPolicy] = useState(null);
  const [inTransitCounted, setInTransitCounted] = useState(false);

  const ropOptions = [
    { label: "Fixed ROP", value: "fixed" },
    { label: "Dynamic ROP", value: "dynamic" },
  ];

  const frequencyOptions = [
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
  ];

  const backorderOptions = [
    { label: "Allow Backorders", value: "allow" },
    { label: "Do Not Allow", value: "deny" },
    { label: "Conditional", value: "conditional" },
  ];
  

  const [minInventoryLevel, setMinInventoryLevel] = useState(100);
  const [maxInventoryLevel, setMaxInventoryLevel] = useState(1000);
  const [lotsize,setLotsize] = useState(100)



  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n")

  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [orderConformationSweetAlert,setOderConformationSweetAlert] = useState({
    show:false,

  })

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    if (basicTitle !== "Please fill all the fields"){
      localStorage.setItem('activeTab', "inventory");
    window.location.reload();
    }


   }

  
  useEffect(() => {
    const fetchData = async () => {
          setLoadshow("show-m");
          setOverlayBlock("show-m");
      try {
        const response = await redirectURL.post("inventory/fetchConfigurations", {});
        if (response.status === 200) {
            if (response.data.data.length > 0) {
              const data = response.data.data[0].inventory_policies ? JSON.parse(response.data.data[0].inventory_policies) : {};  
              if (Object.keys(data).length > 0) {  // Checking if data is not empty
                setRopMethod(data.ropMethod);
                setMinInventoryLevel(data.minInventoryLevel);
                setMaxInventoryLevel(data.maxInventoryLevel);
                setInTransitCounted(data.inTransitCounted);
                setLotsize(data.lotsize);
                setOrderFrequency(data.orderFrequency);
              }
            }
              setLoadshow("show-n");
              setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicTitle("Something Went Wrong");
          setBasicType("warning");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicTitle("Something Went Wrong");
        setBasicType("warning");
      }
    };

    fetchData();
  }, []); // Empty dependency array to run only once when the component mounts


  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const handleProcessConformation = async() => {
      setOderConformationSweetAlert({show:false})

      if (ropMethod === null ||orderFrequency === null ){
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Please fill all the fields");
              setBasicType("warning");
              return;
      }

      setLoadshow("show-m")
      setOverlayBlock("show-m")
      const data = JSON.stringify({
        ropMethod: ropMethod,
        minInventoryLevel: minInventoryLevel,
        maxInventoryLevel: maxInventoryLevel,
        inTransitCounted: inTransitCounted,
        lotsize: lotsize,
        orderFrequency: orderFrequency
      });
      const params = {
                    screenName :"inventory_policies",
                    data : data
          }
      const response = await redirectURL.post("inventory/saveConfigurations", params)
      if (response.status === 200){
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Successfully Saved");
              setBasicType("success");
      }
      else{
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Something Went Wrong");
              setBasicType("warning");
      }
  }
  
  const handleProcessCancel = () => {
      setOderConformationSweetAlert({show:false})
  }
  const saveConfigurations = async() => {
    setOderConformationSweetAlert({show:true})
    }


  return (
    <div className="container-fluid">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
        </div>
        <div style={{ zIndex: "9999999" }}>
            
            <SweetAlert
              show={orderConformationSweetAlert.show}
              title="Are you sure?"
              type="info"
              showCancel
              confirmBtnText="Yes"
              cancelBtnText="No"
              confirmBtnStyle={{
                backgroundColor: "#007bff",
                color: "#fff",
                fontWeight: "bold",
                border: "none",
                borderRadius: "4px",
                padding: "6px 16px",
                fontSize: "14px",
              }}
              cancelBtnStyle={{
                backgroundColor: "#ea5e5e",
                color: "#fff",
                fontWeight: "bold",
                border: "none",
                borderRadius: "4px",
                padding: "6px 16px",
                fontSize: "14px",
              }}
              onConfirm={handleProcessConformation}
              onCancel={handleProcessCancel}
              focusCancelBtn
            >
                 Do you want to save Configurations?
            </SweetAlert>
        </div>
        <div className="mb-4">
          <h4 className="fw-bold">
            📦 Inventory Policies
          </h4>
          <p className="text-muted">Configure inventory management and ordering policies</p>
        </div>

        <div className="row">
          {/* Left Card - Reorder Point & Levels */}
          <div className="col-md-6 mb-4">
            <div className="p-4 border rounded bg-white shadow-sm">
              <h5 className="fw-bold mb-1">Reorder Point & Levels</h5>
              <p className="text-muted">Configure inventory level calculations</p>

              <label className="form-label">ROP Calculation Method</label>
              <Select
                options={ropOptions}
                value={ropMethod}
                onChange={setRopMethod}
                placeholder="Select ROP method"
                className="mb-3"
              />

              <div className="d-flex gap-3 mb-3">
                <div className="flex-fill">
                  <label className="form-label">Min Inventory Level</label>
                  <input
                    type="number"
                    id="minInventoryLevel"
                    className="form-control"
                    value={minInventoryLevel}
                    onChange={(e) => setMinInventoryLevel(e.target.value)}
                    min={0}
                  />                
                  </div>
                <div className="flex-fill">
                  <label className="form-label">Max Inventory Level</label>
                  <input
                    type="number"
                    id="minInventoryLevel"
                    className="form-control"
                    value={maxInventoryLevel}
                    onChange={(e) => setMaxInventoryLevel(e.target.value)}
                    min={0}
                  />                 
                  </div>
              </div>

              <label className="form-label">Order Frequency</label>
              <Select
                options={frequencyOptions}
                value={orderFrequency}
                onChange={setOrderFrequency}
                placeholder="Select frequency"
              />
            </div>
          </div>

          {/* Right Card - Order & Transit Policies */}
          <div className="col-md-6 mb-4">
            <div className="p-4 border rounded bg-white shadow-sm">
              <h5 className="fw-bold mb-1">🚚 Order & Transit Policies</h5>
              <p className="text-muted">Configure ordering and in-transit inventory rules</p>

              <label className="form-label">Lot Size / MOQ</label>
                  <input
                    type="number"
                    id="lot-size"
                    className="form-control"
                    value={lotsize}
                    onChange={(e) => setLotsize(e.target.value)}
                    min={0}
                  />                
              <small className="text-muted">Minimum order quantity per SKU</small>

              <div className="form-check form-switch mt-3 mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="inTransitToggle"
                  checked={inTransitCounted}
                  onChange={() => setInTransitCounted(!inTransitCounted)}
                />
                <label className="form-check-label" htmlFor="inTransitToggle">
                  Count In-Transit as Stock
                </label>
                <div className="text-muted" style={{ fontSize: "13px" }}>
                  Include in-transit inventory in calculations
                </div>
              </div>

              {/* <label className="form-label">Backorder Handling Policy</label>
              <Select
                options={backorderOptions}
                value={backorderPolicy}
                onChange={setBackorderPolicy}
                placeholder="Select backorder policy"
                className="mb-3"
              /> */}

              {/* <label className="form-label">Order Batching Window (hours)</label>
              <input type="number" className="form-control" defaultValue={24} /> */}
            </div>
          </div>
          <div className="col-sm-12" style={{textAlign: "right", display : "flex", justifyContent: "flex-end"}}>
                <button 
                    onClick={() => { saveConfigurations() }}
                    style={{
                      
                      padding: "10px 20px",
                      backgroundColor: "#991548",
                      color: "white",
                      border: "none",
                      borderRadius: 8,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                      >
                        Save All Configurations
                </button>
          </div>
        </div>

        <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
          <div className={`overlay-block ${overlayBlock}`}></div>
          <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </div>
  );
};

export default InventoryPolicies;
